import { Outlet } from "react-router";
import { FilterProvider } from "../../../context/FilterProvider";

const WSRBDetailFilter = () => {
    return (
        <FilterProvider>
            <Outlet />
        </FilterProvider>
    );
}

export default WSRBDetailFilter;
